import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ClearTrashSelection extends Action<StorymapState> {
    public static ACTION_TYPE = 'ClearTrashSelection';

    public constructor() {
        super(ClearTrashSelection.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    state.trashState.selectedRowId = null;
};

//@ts-ignore
registerReducer(ClearTrashSelection.ACTION_TYPE, reducer);
